/**
 * ARCHIVO DE GESTIÓN DE CONVOCATORIAS CAS
 * ---------------------------------------------------------------------------
 * INSTRUCCIONES PARA AGREGAR UNA NUEVA CONVOCATORIA:
 * 
 * 1. PASO 1 (Copiar PDFs): 
 *    - Todas tus bases y resultados en formato PDF, guárdalos dentro de la 
 *      carpeta de tu proyecto en la ruta:  public/documents/convocatorias/ 
 *      (Si no existe la carpeta, créala).
 * 
 * 2. PASO 2 (Registrar datos aquí):
 *    - Copia un bloque completo encerrado con llaves { ... } y complétalo.
 *    - "id": Un número único que no se repita.
 *    - "number": El N° de la convocatoria.
 *    - "title": El cargo o nombre de la convocatoria.
 *    - "period": Mes y año (Ej. "Mayo 2026").
 *    - "status": Solo escribe "VIGENTE", "EN PROCESO", o "CONCLUIDO". El color cambiará solo.
 * 
 * 3. PASO 3 (Añadir enlaces de documentos):
 *    - Escribe el nombre exacto de tu PDF dentro de las comillas. 
 *    - Ej: bases: "Bases_001.pdf"
 *    - Si una etapa aún no se realiza, simplemente déjala como null o quítale las comillas
 *      luego de los dos puntos. El sistema ocultará el botón automáticamente.
 */

// Función interna generadora de enlaces (no necesitas tocar esto)
const baseFolder = "/documents/convocatorias/";
const formatLink = (file) => file ? `${baseFolder}${file}` : null;

export const convocatoriasCASData = [
  // COPIA DESDE AQUÍ PARA CREAR OTRA CONVOCATORIA
 {
    id: 1,
    number: "PROCESO DE SELECCIÓN CAS TRANSITORIO N° 004-2026-MDP",
    title: "(SUB GERENTE DE LOGISTICA Y CONTROL PATRIMONIAL)",
    period: "setiembre 2026", 
    Postulacion: "18-09-2026 (08:00 horas) hasta 18-09-2026 (17:30 horas)",
    status: "CONCLUIDO", 
    documents: {
      bases: "CAS 04/CONVOCATORIA CAS 04.pdf",     // <--- Aquí pones tu archivo: "MiBase1.pdf"
      anexos: "CAS 04/ANEXOS.docx",                      // <--- Cuando este listo el archivo, cambia null por "Resultados_Fase1.pdf"
      curricular: "CAS 04/ACTA DE EVALUACION CURRICULAR.pdf",       // <--- Cuando este listo el archivo, cambia null por "Resultados_Fase1.pdf"
      entrevista: "CAS 04/ACTA DE EVALUACION PERSONAL Y FINAL .pdf",
      resultado: "CAS 04/ACTA DE EVALUACION PERSONAL Y FINAL .pdf",
      observaciones: "CAS 04/ACTA DE POSTERGACION EVALUACION CURRICULAR .pdf"
          }
  },

  {
    id: 1,
    number: "PROCESO DE SELECCIÓN CAS TRANSITORIO N° 003-2026-MDP",
    title: "(JEFE  DE  LA  OFICINA  DE  DEFENSA  CIVIL,  TRANSPORTE  Y  SEGURIDAD  VIAL) y (SUB GERENTE DE LOGISTICA Y CONTROL PATRIMONIAL)",
    period: "junio 2026", 
    Postulacion: "15-06-2026 (08:00 horas) hasta 15-06-2026 (17:30 horas)",
    status: "CONCLUIDO", 
    documents: {
      bases: "CAS 03/CONVOCATORIA CAS 03.pdf",     // <--- Aquí pones tu archivo: "MiBase1.pdf"
      anexos: "CAS 03/ANEXOS.docx",                      // <--- Cuando este listo el archivo, cambia null por "Resultados_Fase1.pdf"
      curricular: "CAS 03/EVALUACION CURRICULAR.pdf",       // <--- Cuando este listo el archivo, cambia null por "Resultados_Fase1.pdf"
      entrevista: "CAS 03/Acta de Entrevista Personal y Resultado Final.pdf",
      resultado: "CAS 03/Acta de Entrevista Personal y Resultado Final.pdf",
      observaciones: "CAS 03/Acta de Desierto.pdf"
          }
  },
  // HASTA AQUÍ. ASEGÚRATE DE PONER UNA COMA (,) AL FINAL DE LA LLAVE DE ARRIBA 
  
  {
    id: 1,
    number: "PROCESO DE SELECCIÓN CAS TRANSITORIO N° 002-2026-MDP",
    title: "(JEFE  DE  LA  OFICINA  DE  DEFENSA  CIVIL,  TRANSPORTE  Y  SEGURIDAD  VIAL) y (SUB GERENTE DE LOGISTICA Y CONTROL PATRIMONIAL)",
    period: "Abril 2026", 
    Postulacion: "12-05-2026 (08:00 horas) hasta 12-05-2026 (17:30 horas)",
    status: "CONCLUIDO", 
    documents: {
      bases: "CAS 02/BASES PROCESO CAS II-2026.pdf",     // <--- Aquí pones tu archivo: "MiBase1.pdf"
      anexos: "CAS 02/ANEXOS.docx",                      // <--- Cuando este listo el archivo, cambia null por "Resultados_Fase1.pdf"
      curricular: "CAS 02/Acta de Evaluacion curricular.pdf",       // <--- Cuando este listo el archivo, cambia null por "Resultados_Fase1.pdf"
      entrevista: null,
      resultado: null,
      observaciones: "CAS 02/ACTA DE DESIERTO.pdf"
          }
  },
  // HASTA AQUÍ. ASEGÚRATE DE PONER UNA COMA (,) AL FINAL DE LA LLAVE DE ARRIBA 
  
  {
    id: 2,
    number: "PROCESO DE SELECCIÓN CAS TRANSITORIO N° 001-2026-MDP",
    title: "(JEFE  DE  LA  OFICINA  DE  DEFENSA  CIVIL,  TRANSPORTE  Y  SEGURIDAD  VIAL) y (SUB GERENTE DE LOGISTICA Y CONTROL PATRIMONIAL) y (JEFE DEL AREA  DE DEMUNA)",
    period: "Marzo 2026",
    Postulacion: "26-03-2026 (08:00 horas) hasta 26-03-2026 (17:30 horas)",
    status: "CONCLUIDO",
    documents: {
      bases: "CAS 01/BASES CONVOCATORIA CAS - 2026.pdf",
      verificacion: "CAS 01/ANEXOS .docx",
      conocimientos: "CAS 01/Acta de Evalucion Curricular-1.pdf",
      entrevista: "CAS 01/RESULTADOS DE LA ENTREVISTA PERSONAL..pdf",
      resultados: "CAS 01/RESULTADOS DE LA ENTREVISTA PERSONAL..pdf",
      observaciones: "CAS 01/ACTA DECLARANDO DESIERTO.pdf",
    }
  },
 
].map(conv => ({
  ...conv,
  documents: {
    bases: formatLink(conv.documents.bases),
    verificacion: formatLink(conv.documents.verificacion || conv.documents.anexos),
    conocimientos: formatLink(conv.documents.conocimientos || conv.documents.curricular),
    entrevista: formatLink(conv.documents.entrevista),
    resultados: formatLink(conv.documents.resultados || conv.documents.resultado),
    observaciones: formatLink(conv.documents.observaciones),
  }
}));
